import React from "react";
import PropTypes from "prop-types";
import "../../css/Cards/CardImageRow.css";
import Image from "../ImageElement";

/**
 * CardImageRow component
 */
class CardImageRow extends React.Component {
  static displayName = "CardImageRow";
  static propTypes = {
    className: PropTypes.string,
    images: PropTypes.object,
    title: PropTypes.string.isRequired,
    screen: PropTypes.string.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardImageRow";
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div className={`${this.className}__title`}>{this.props.title}</div>
        <div className={`${this.className}__images`}>
          {this.props.images.map((img) => (
            <a
              href={img.href}
              key={img.ID}
              rel="noopener noreferrer"
              className={`${this.className}__img`}
            >
              <Image src={img[`${this.props.screen}_src`]} alt={img.alt} />
            </a>
          ))}
        </div>
      </div>
    );
  }
}

export default CardImageRow;



// WEBPACK FOOTER //
// ./src/components/Cards/CardImageRow.js